import { createFileRoute } from '@tanstack/react-router';

import { OrderMapPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/orders_/$id/map')({
  component: OrderMapPage,
});
